import React, { useEffect, useState } from "react";
import Page from "components/Page";
import { Card } from "reactstrap";
import styles from "./accountpreferences.module.scss";
import ChatIcon from "assets/images/MulticolorChatIcon.svg";
import AppointmentReminderIcon from "assets/images/appointment_reminder_plan.svg";
import RecallReminderIcon from "assets/images/recall_reminder.svg";
import CompanyBrandingIcon from "assets/images/company_branding.svg";
import DocumentIcon from "assets/images/document_icon.svg";
import Policy_Acknowledge_Template from "assets/images/policy_acknowledge_template.svg";
import ManageSubscriptions from "assets/images/manage-subscription.svg";
import Holidays from "assets/images/holidays.svg";
import credentialAndLicensingIcon from "assets/images/crendentialAndLicensingIcon.svg"
import StaffRoles from "assets/images/staff-roles.svg";
import constants from "./../../constants";
import { withTranslation } from "react-i18next";
import { handleError, handleSuccess, setStorage } from "utils";
import { useDispatch } from "react-redux";
import QuestimIcon from "assets/images/question_mark.svg";
import AccountPreferencesInfoModal from "./AccountPreferencesInfoModal";
import { updateAiToggleToHeader } from "repositories/ai-assistant-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import ToggleSwitch from "components/ToggleSwitch";
import Text from "components/Text";
import { getProfile } from "actions";
import Loader from "components/Loader";

const AccountPrefences = ({ history, t }) => {
  const dispatch = useDispatch();
  const {
    isOwner,
    isStaff,
    isAdmin: isStaffAndAdmin,
    profile,
    ownerList
  } = useAccountOwnerCommon();

  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [toggleOn, setToggleOn] = useState();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setToggleOn(!profile?.showWebAiToggleInHeader);
  }, [profile]);

  const handleReminderClick = () => {
    history.push(constants.routes.appointment.AccountGlobalReminder);
    setStorage("isRecallReminderPlan", {
      isRecallReminderPlan: false,
    });
  };

  const handleRecallClick = () => {
    history.push(constants.routes.appointment.AccountGlobalReminder);
    setStorage("isRecallReminderPlan", {
      isRecallReminderPlan: true,
    });
  };

  const handleRedirect = (urlToRedirect) => {
    history.push(urlToRedirect);
  };

  const handleToggle = async () => {
    const newToggleState = !toggleOn;
    setToggleOn(newToggleState);

    setShowLoader(true);
    try {
      const res = await updateAiToggleToHeader(!newToggleState);
      handleSuccess(res?.message);
      dispatch(getProfile(undefined, { silent: true }));
    } catch (error) {
      handleError(error);
      setToggleOn(toggleOn);
    } finally {
      setShowLoader(false);
    }
  };

  const accountList = [
    {
      id: 1,
      chatImg: ChatIcon,
      accountName: t("accountPreferences.messageTemplates"),
      onclick: () =>
        handleRedirect(constants.routes.accountPreference.messageTemplates),
    },
    {
      id: 2,
      chatImg: AppointmentReminderIcon,
      accountName: t("accountPreferences.appointmentReminderPlan"),
      onclick: handleReminderClick,
    },
    {
      id: 3,
      chatImg: RecallReminderIcon,
      accountName: t("accountPreferences.appointmentRecallPlan"),
      onclick: handleRecallClick,
    },
  ];

  const goBack = () => history.push(constants.routes.accountOwner.offices);

  return (
    <>
      {showLoader && <Loader />}
      <Page
        onBack={goBack}
        className={styles["global-main-page"]}
        title={t("accountPreferences.accountSettingAndPreferences")}
        actionButton={
          <button
            type="button"
            className={styles.question_btn}
            onClick={() => setIsInfoModalOpen(true)}
          >
            <img src={QuestimIcon} alt="QuestimIcon" />
            <p className="m-0">{t("navbar.help")}</p>
          </button>
        }
      >
        <div className={styles["new-instruction-messages"]}>
          <Card className={styles["instruction-card"]}>
            <div className={styles["toggle-wrapper"]}>
              <ToggleSwitch
                label="bill-me-later-toggle"
                customClass={"mt-2"}
                value={!!toggleOn}
                onChange={handleToggle}
              />
              <div>
                <Text size="14px" weight="600" color="#2F3245">
                  {t("aiAssistant.onlineChat.showAiSetting")}
                </Text>
                <Text size="13px" weight="400" color="#79869A">
                  {t("aiAssistant.onlineChat.showAiSettingSubHeading")}
                </Text>
              </div>
            </div>
          </Card>
        </div>
        <div className={styles["manage-card-container"]}>
            <p className={`${styles["mobile-text-size"]} ${styles["account-preference-title-margin"]}`}>
            {t("accountPreferences.patientSchedulingTemplates")}
          </p>
          <div className={styles.account_preferences_wrapper}>
            {accountList.map((item) => (
              <div
                className={styles["card-con"] + " form-wrapper cursor-pointer"}
                onClick={item.onclick}
                key={item.id}
              >
                <Card
                  className={
                    styles["account-preference-card"] +
                    " " +
                    "d-flex align-items-center flex-row w-100"
                  }
                >
                  <div className={styles["account-preference-logo"]}>
                    <img
                      key={item.id}
                      src={item.chatImg}
                      alt="message template icon"
                    />
                  </div>
                  <div
                    className={styles["account-preference-text"]}
                    key={item.id}
                  >
                    {item.accountName}
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
        {(isOwner||(isStaff && ownerList.length > 0)) && (
          <>
            <div className={styles["manage-card-container"]}>
              <p className={styles["mobile-text-size"] + " mt-4"}>
                {t("accountPreferences.organizationSettings")}
              </p>
              <div className={styles.account_preferences_wrapper}>
               {isOwner&&<>
                <div
                  className={
                    styles["card-con"] + " form-wrapper cursor-pointer"
                  }
                  onClick={() => {
                    handleRedirect(constants.routes.accountOwner.managePlan);
                  }}
                >
                  <Card
                    className={
                      styles["account-preference-card"] +
                      " " +
                      "d-flex align-items-center flex-row w-100"
                    }
                  >
                    <div className={styles["account-preference-logo"]}>
                      <img
                        src={ManageSubscriptions}
                        alt="Manage Subscriptions"
                      />
                    </div>
                    <div className={styles["account-preference-text"]}>
                      {t("navbar.manageSubscription")}
                    </div>
                  </Card>
                </div>
                <div
                  className={
                    styles["card-con"] + " form-wrapper cursor-pointer"
                  }
                  onClick={() => {
                    handleRedirect(constants.routes.accountOwner.staffRoles);
                  }}
                >
                  <Card
                    className={
                      styles["account-preference-card"] +
                      " " +
                      "d-flex align-items-center flex-row w-100"
                    }
                  >
                    <div className={styles["account-preference-logo"]}>
                      <img src={StaffRoles} alt="Add Staff Roles" />
                    </div>
                    <div className={styles["account-preference-text"]}>
                      {t("navbar.addstaffRoles")}
                    </div>
                  </Card>
                </div>
                <div
                  className={
                    styles["card-con"] + " form-wrapper cursor-pointer"
                  }
                  onClick={() => {
                    handleRedirect(
                      constants.routes.accountOwner.manageHolidays
                    );
                  }}
                >
                  <Card
                    className={
                      styles["account-preference-card"] +
                      " " +
                      "d-flex align-items-center flex-row w-100"
                    }
                  >
                    <div className={styles["account-preference-logo"]}>
                      <img src={Holidays} alt="Add Holidays" />
                    </div>
                    <div className={styles["account-preference-text"]}>
                      {t("navbar.addholidays")}
                    </div>
                  </Card>
                </div>
               </>}
                <div
                  className={
                    styles["card-con"] + " form-wrapper cursor-pointer"
                  }
                  onClick={() => {
                    handleRedirect(
                      constants.routes.credentialsAndLicensing.credentialsAndLicensing
                    );
                  }}
                >
                  <Card
                    className={
                      styles["account-preference-card"] +
                      " " +
                      "d-flex align-items-center flex-row w-100"
                    }
                  >
                    <div className={styles["account-preference-logo"]}>
                      <img src={credentialAndLicensingIcon} alt="Add Holidays" />
                    </div>
                    <div className={styles["account-preference-text"]}>
                      {t("accountOwner.credentialsAndLicensing")}
                    </div>
                  </Card>
                </div>
             
              </div>
            </div>
          </>
        )}
        {isOwner&& <div className={styles["manage-card-container"]}>
           <p className={styles["mobile-text-size"] + " mt-4"}>
             {t("accountPreferences.accountSetup")}
           </p>
           <div className="d-flex justify-content-between">
             <div
               className={
                 styles["card-con"] + " form-wrapper cursor-pointer"
               }
               onClick={() => {
                 handleRedirect(
                   constants.routes.accountPreference.companyBranding
                 );
               }}
             >
               <Card
                 className={
                   styles["account-preference-card"] +
                   " " +
                   "d-flex align-items-center flex-row w-100"
                 }
               >
                 <div className={styles["account-preference-logo"]}>
                   <img
                     src={CompanyBrandingIcon}
                     alt="message template icon"
                   />
                 </div>
                 <div className={styles["account-preference-text"]}>
                   {t("accountPreferences.companyBranding")}
                 </div>
               </Card>
             </div>
           </div>
         </div>}
        {(isStaffAndAdmin || isOwner) && (
          <div className={styles["manage-card-container"]}>
            <p className={styles["mobile-text-size"] + " " + "mt-4"}>
              {t("aiAssistant.aiSettings")}
            </p>
            <div className="d-flex justify-content-between">
              <div
                className={
                  styles["card-con"] + " " + "form-wrapper cursor-pointer"
                }
                onClick={() => {
                  handleRedirect(
                    constants.routes.aiAssistant.manageAiDocuments
                  );
                }}
              >
                <Card
                  className={
                    styles["account-preference-card"] +
                    " " +
                    "d-flex align-items-center flex-row w-100"
                  }
                >
                  <div className={styles["account-preference-logo"]}>
                    <img src={DocumentIcon} alt="message template icon" />
                  </div>
                  <div className={styles["account-preference-text"]}>
                    {t("aiAssistant.manageDocument")}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
        {isInfoModalOpen && (
          <AccountPreferencesInfoModal
            isOpen={isInfoModalOpen}
            onClose={setIsInfoModalOpen}
          />
        )}
        {(isStaffAndAdmin || isOwner) && (
          <div className={styles["manage-card-container"]}>
            <p className={styles["mobile-text-size"] + " mt-4"}>
              {t("accountPreferences.policyPreferences")}
            </p>
            <div className="d-flex justify-content-between">
              <div
                className={styles["card-con"] + " form-wrapper cursor-pointer"}
                onClick={() => {
                  handleRedirect(
                    constants.routes.accountPreference
                      .policyAcknowledgementTemplate
                  );
                }}
              >
                <Card
                  className={
                    styles["account-preference-card"] +
                    " " +
                    "d-flex align-items-center flex-row w-100"
                  }
                >
                  <div className={styles["account-preference-logo"]}>
                    <img
                      src={Policy_Acknowledge_Template}
                      alt="message template icon"
                    />
                  </div>
                  <div className={styles["account-preference-text"]}>
                    {t("accountPreferences.policyAcknowledgementTemplate")}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </Page>
    </>
  );
};

export default withTranslation()(AccountPrefences);
